import { type PropsWithChildren, Suspense } from 'react'
import { LoadPageProgress, ScaledLayout } from '~sharedUI'
import { ContentBackground } from '~widgets/index'

export const PageWrapper = ({ children }: PropsWithChildren) => {
	return (
		<Suspense fallback={<LoadPageProgress />}>
			<ContentBackground>
				<ScaledLayout>{children}</ScaledLayout>
			</ContentBackground>
		</Suspense>
	)
}
